import { createStore } from 'src/util/mobx/generic-store/store-creator'
import { GenericStore } from 'src/util/mobx/generic-store/generic.store'
import { GenericStoreAsyncMethod } from 'src/util/mobx/generic-store/decorator/async-method.decorator'
import {
  getTeamStructureByPrompt,
  getTeamTemplatesByIndustry,
  OnboardingLevelResponse,
  TeamTemplateOption,
} from '../api/onboarding'

export class OnboardingStore extends GenericStore {
  teamTemplates: TeamTemplateOption[] = []
  teamStructure: OnboardingLevelResponse[] = []
  lastFetchedTemplatesIndustry = ''

  constructor() {
    super('OnboardingStore')
    super.observe(this)
  }

  @GenericStoreAsyncMethod()
  async fetchTeamTemplates(industry: string) {
    if (this.lastFetchedTemplatesIndustry === industry) {
      return
    }

    this.teamTemplates = await getTeamTemplatesByIndustry(industry)
    this.lastFetchedTemplatesIndustry = industry
  }

  clearTeamTemplates() {
    this.teamTemplates = []
    this.lastFetchedTemplatesIndustry = ''
  }

  @GenericStoreAsyncMethod()
  async fetchTeamStructure(prompt: string) {
    this.teamStructure = await getTeamStructureByPrompt(prompt)
  }
}

export const {
  storeInstance: onboardingStoreInstance,
  StoreProvider: OnboardingStoreProvider,
  useStore: useOnboardingStore,
} = createStore(new OnboardingStore())
